import * as actions from './consts'
import _ from 'lodash'

const ACTION_HANDLERS = {
  [actions.LISTS_GET_SUCCESS]: (state, { lists }) => {
    return lists;
  },
  [actions.LIST_DELETE_SUCCESS]: (state, { name }) => {
    const s = [...state];

    _.pull(s, name)

    return s;
  },
}

const initialState = []

export default function listsReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}
